import * as React from "react";
import Link from "next/link";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { IPaymentMethodFormType } from "@nju/data-access-portal-payment";
import { pushSimpleEvent } from "@nju/data-layer";
import { portalRoutes } from "@nju/routes";
import { A, Button } from "@nju/ui";
import { mapPaymentMethod } from "./utils/mapPaymentMethod";

interface IButtonsProps {
  paymentMethod: IPaymentMethodFormType | undefined;
  handleAddCreditCard: () => void;
  isLoading: boolean;
  handlePayByLink: () => void;
  userId: string | undefined;
}

export function Buttons({
  paymentMethod,
  userId,
  handleAddCreditCard,
  isLoading,
  handlePayByLink,
}: IButtonsProps) {
  const mode = useOfferMode();
  const nextButtonAction =
    !paymentMethod || paymentMethod == "CREDIT_CARD"
      ? handleAddCreditCard
      : handlePayByLink;

  const handlePushDataLayer = React.useCallback(() => {
    const eventName = mapPaymentMethod(paymentMethod);

    if (eventName) {
      pushSimpleEvent({
        event: "choose_payment_method",
        eventName,
      });
    }
  }, [paymentMethod]);

  const handleNextStep = React.useCallback(
    function () {
      handlePushDataLayer();
      nextButtonAction();
    },
    [handlePushDataLayer, nextButtonAction],
  );

  return (
    <div className="flex flex-col-reverse from-desktop:flex-row justify-between gap-3">
      <Link
        href={portalRoutes.mojeKonto.index.get({
          mode,
          ...(userId && { userId }),
        })}
        passHref={true}
      >
        <A
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
          variant="secondary"
        >
          powrót
        </A>
      </Link>
      {(!paymentMethod ||
        paymentMethod == "CREDIT_CARD" ||
        paymentMethod == "PAY_BY_LINK") && (
        <Button
          isLoading={isLoading}
          onPress={handleNextStep}
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          dalej
        </Button>
      )}

      {paymentMethod === "DIGITAL_WALLET" && (
        <Link
          href={portalRoutes.mojeKonto.platnosc.blik.index.get({
            mode,
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A
            data-cy="digital-wallet-pay-now"
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            dalej
          </A>
        </Link>
      )}
    </div>
  );
}
